module.exports = __webpack_public_path__ + "img/task2888.e3a56caf.png";